import { useState } from 'react';
import { COLOR_PALETTES, randomizeRecipe } from '../../../themes/colorPalettes';
import type { ThemeRecipe } from '../../../themes/recipe';

interface ColorsSectionProps {
  readonly value: ThemeRecipe;
  readonly onChange: (recipe: ThemeRecipe) => void;
}

type Mode = 'palette' | 'single' | 'randomize';

export function ColorsSection({ value, onChange }: ColorsSectionProps) {
  const [mode, setMode] = useState<Mode>('palette');

  return (
    <fieldset className="theme-editor__section">
      <legend>Värit</legend>
      <div className="theme-editor__tabs">
        <TabButton current={mode} value="palette" onClick={setMode}>
          Paletti
        </TabButton>
        <TabButton current={mode} value="single" onClick={setMode}>
          Yksi väri
        </TabButton>
        <TabButton current={mode} value="randomize" onClick={setMode}>
          Arvo värit
        </TabButton>
      </div>

      {mode === 'palette' ? (
        <div className="theme-editor__palette-grid">
          {COLOR_PALETTES.map((p) => (
            <button
              key={p.key}
              type="button"
              className="theme-editor__palette-tile"
              onClick={() => onChange(p.recipe)}
              style={{ background: p.recipe.base }}
              title={p.name}
            >
              {p.name}
            </button>
          ))}
        </div>
      ) : null}

      {mode === 'single' ? (
        <label className="theme-editor__single-color">
          <span>Pohjaväri</span>
          <input
            type="color"
            value={value.base}
            onChange={(e) => onChange({ base: e.target.value, mood: value.mood ?? 'bright' })}
          />
        </label>
      ) : null}

      {mode === 'randomize' ? (
        <button
          type="button"
          className="theme-editor__randomize"
          onClick={() => onChange(randomizeRecipe(Date.now() & 0xffff))}
        >
          Arvo uudet värit
        </button>
      ) : null}
    </fieldset>
  );
}

function TabButton({
  current,
  value,
  onClick,
  children,
}: Readonly<{
  current: Mode;
  value: Mode;
  onClick: (m: Mode) => void;
  children: React.ReactNode;
}>) {
  return (
    <button
      type="button"
      className={current === value ? 'active' : ''}
      onClick={() => onClick(value)}
    >
      {children}
    </button>
  );
}
